



























































































































































































































































































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import Upload from '../components/uploadImage.vue';
import { editGoods } from '@/utils/api';
@Component({
  components: {
    Upload,
  },
})
export default class skuSidebar extends Vue {
  @Prop(Boolean) skuData: boolean | undefined;
  @Prop(Object) skuList: object | undefined;
  $refs: any;
  form: any = {
    name: '',
    region: '',
    jian: '件',
  };
  centerDialogVisible: boolean = false; //对话框
  imgs: any = [];
  fage: boolean = false; //图片弹框开关
  dialog: boolean = false;
  formLabelWidth: String = '90px';
  skuguige: any = []; //sku 规格
  list: any = {}; //sku数据
  openDrawer() {
    this.$nextTick(() => {
      this.list = this.skuList;
      if (this.list['commoditySkuInfo']) {
        // this.list = JSON.parse(JSON.stringify(this.skuList))

        this.dialog = true;
        if (this.list['skuSign']) {
          this.activeName1 = this.list['skuSign'];
        }
        this.skuguige = [];

        this.list['commoditySkuInfo'].forEach((item, index) => {
          if (item.skuSpecifications) {
            var str = '';
            item.skuSpecifications.forEach((item1, i) => {
              console.log(i+1);


              if (i>0) {
                str = str + ' ' + '|' + ' ' + item1.specItemValue;
              } else {
                str = str + item1.specItemValue;
              }
            });
            this.skuguige.push(str);
          }
        });
      }
    });
  }
  tabarimg: any = [];
  // 自定义校验规则
  checkAge: any = (rule, value, callback) => {
    if (!value&&value!=0) {


      return callback(new Error('不能为空'));
    }

    setTimeout(() => {
      if (isNaN(value)) {
        callback(new Error('请输入数字值'));
      } else {
        if (value < 0) {
          callback(new Error('不能小于0'));
        } else {
          callback();
        }
      }
    }, 1000);
  };
  rules: any = {
    name: [{ required: true, message: '请输入活动名称', trigger: 'blur' }],
    name1: [{ required: true, message: '请输入活动名称', trigger: 'blur' }],
    name2: [{ required: true, message: '请输入活动名称', trigger: 'blur' }],
    name3: [{ required: true, message: '请输入活动名称', trigger: 'blur' }],
    suggestCostPrice: [{ required: true, validator: this.checkAge, trigger: 'blur' }],

    'commoditySkuInfo.activeName1.suggestCostPrice': [{ required: true, validator: this.checkAge, trigger: 'blur' }],
  };
  value: boolean = true;

  limit: Number = 5;
  fileList: any = [];
  activeName1: number | string = 0;
  // 保存
  determine() {
    console.log(this.skuList);
    (this.$refs['skuList'] as any).validate((valid) => {
      if (valid) {
        if (this.list['skuSign']) {
          this.$emit('sendCommoditySkuInfo', this.list['commoditySkuInfo']);
          this.centerDialogVisible = false;
          this.dialog = false;
        } else {
          editGoods(this.list)
            .then((res) => {
              this.$message({
                message: `${res}`,
                type: 'success',
              });
              this.$emit('goodsmanage', '999');
              this.centerDialogVisible = false;
              this.dialog = false;
            })
            .catch((error: any) => {
              console.log(error);
              this.centerDialogVisible = false;
              this.dialog = false;
            });
        }
      } else {
        return false;
      }
    });
  }
  // input限制
  changexianzhi(e){
    this.list.commoditySkuInfo[this.activeName1].skuCode=this.list.commoditySkuInfo[this.activeName1].skuCode.replace(/[^\a-\z\A-\Z0-9\.\u4e00-]/g, '')
    // this.list.commoditySkuInfo[this.activeName1].hight=this.list.commoditySkuInfo[this.activeName1].hight.replace(/[^\d]/g, '')
    // this.list.commoditySkuInfo[this.activeName1].length=this.list.commoditySkuInfo[this.activeName1].length.replace(/[^\d]/g, '')
  }
  // 切换tab
  async qiehuan(activeName, oldActiveName) {
    // console.log(" 我是默认",this.$refs['skuList']);
    let flag = false;
    if (!this.$refs['skuList']) {
      console.log('1111111');
      flag = true;
    } else {
      const fun = async () => {
        const a = await this.$refs['skuList'].validate();
      };

      await fun();
    }

    return flag;
  }
  //商品详情
  productDetails(spuId) {
    // console.log(spuId);
    if (spuId && spuId != '') {
      this.$router.push({ path: '/goods/goodsEdit/goodsEdit', query: { spuid: spuId } });
    }
    this.centerDialogVisible = false;
    this.dialog = false;
  }
  // 选择sku事件
  tabsku(tab) {
    console.log(tab, this.activeName1);
  }
  // sku关闭事件
  skudele() {
    this.activeName1 = '0';
  }
  // sku关闭前的回调
  xuwen(done) {
    this.activeName1 = '0';
    if (this.list['skuSign']) {
      this.dialog = false;
      return;
    }
    this.centerDialogVisible = true;
  }
  // 图片数据
  shangchuan() {
    this.fage = true;
    this.imgs = this.list['commoditySkuInfo'][this.activeName1].spuSkuImages;
  }
  deleteImg(index) {
    this.list['commoditySkuInfo'][this.activeName1].spuSkuImages.splice(index, 1);
  }
  uploadConfirm(e) {
    console.log(e);

    this.list['commoditySkuInfo'][this.activeName1].spuSkuImages = e;
    console.log(this.tabarimg);
  }
  closeUpload(e) {
    this.fage = false;
  }
}
